// // src/pages/items/ItemList.js
// import React, { useEffect, useState } from 'react';
// import {
//   Container,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   IconButton,
//   Box,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import itemService from '../../services/itemService';
// import LayoutContainer from '../../components/LayoutContainer';
// import AdminHeader from '../../components/AdminHeader';
// import { join } from 'lodash';

// const ItemList = () => {
//   const [items, setItems] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchItems = async () => {
//       const response = await itemService.getItems();
//       setItems(response.data);
//     };
//     fetchItems();
//   }, []);

//   const handleDelete = async (id) => {
//     await itemService.deleteItem(id);
//     setItems(items.filter((item) => item.id !== id));
//   };

//   return (
//     <LayoutContainer>
//       <AdminHeader title='Products' />
//       <div className='page-content-wrapper scrollable'>
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//           <Button
//             variant='contained'
//             sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
//             onClick={() => navigate('/items/new')}
//           >
//             Add Product
//           </Button>
//         </Box>
//         <Table className='table'>
//           <TableHead className='tableHead'>
//             <TableRow>
//               <TableCell>Products</TableCell>
//               <TableCell>Station Type</TableCell>
//               {/* <TableCell>Roles</TableCell> */}
//               <TableCell>Action</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody className='tableBody'>
//             {items.map((item, index) => (
//               <TableRow
//                 key={item.id}
//                 sx={{
//                   backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
//                   // '&:hover': { backgroundColor: '#e0f7fa' },
//                 }}
//               >
//                 <TableCell>{item.item_name}</TableCell>
//                 <TableCell>{item.station_type || '-'}</TableCell>
//                 {/* <TableCell>
//                   {item?.product_roles
//                     ? join(JSON.parse(item?.product_roles), ',')
//                     : '-'}
//                 </TableCell> */}
//                 <TableCell>
//                   <IconButton
//                     onClick={() => navigate(`/items/edit/${item.id}`)}
//                   >
//                     <EditIcon sx={{ color: '#be210b' }} />
//                   </IconButton>
//                   {/* <IconButton onClick={() => handleDelete(item.id)}>
//                     <DeleteIcon sx={{ color: '#be210b' }} />
//                   </IconButton> */}
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </div>
//     </LayoutContainer>
//   );
// };

// export default ItemList;

// src/pages/items/ItemList.js
import React, { useEffect, useState } from 'react';
import {
  Button,
  IconButton,
  Box,
  createTheme,
  ThemeProvider,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete'; // Uncomment if you want to re-enable Delete
import itemService from '../../services/itemService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import MUIDataTable from 'mui-datatables'; // Import MUI DataTable component
import { filter, includes, isEqual, map, sortBy } from 'lodash';
import { toast } from 'react-toastify';
import DeleteModal from '../../components/DeleteModal';

const ItemList = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [rowsToDelete, setRowsToDelete] = useState(null);
  const roles = JSON.parse(localStorage?.getItem('roles'));

  const fetchItems = async () => {
    try {
      const response = await itemService.getItems();
      setItems(sortBy(response.data, 'item_name'));
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleDelete = async (data) => {
    const deleteItemIndex = map(data?.data, (data) => data?.dataIndex);
    const deleteItem = filter(items, (data, index) =>
      includes(deleteItemIndex, index)
    );
    try {
      const res = await itemService.deleteProductList({
        table_name: 'products',
        ids: map(deleteItem, 'id'),
      });
      if (res?.status === 204) {
        toast.success('Products deleted successfully');
        setItems(
          items.filter((item, index) => !includes(deleteItemIndex, index))
        );
        setOpenDeleteModal(false);
        fetchItems();
      }
    } catch (e) {
      toast.error('Product already in use. This product cannot be delete');
    }
  };

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'item_name',
      label: 'PRODUCT NAME',
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: 'active',
    //   label: 'Active',
    //   option: {
    //     customBodyRender: (value) => {
    //       return (
    //         <FormControlLabel
    //           control={
    //             <Switch checked={value} onChange={() => ''} name='active' />
    //           }
    //           label=''
    //         />
    //       );
    //     },
    //   },
    // },
    {
      name: 'station_type',
      label: 'STATION TYPE',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? value : '-'),
      },
    },
    {
      name: 'actions',
      label: 'ACTION',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const item = items[tableMeta.rowIndex];

          // console.log('tableMeta', tableMeta?.rowData[0]);

          return (
            <Box sx={{ display: 'flex' }}>
              <IconButton
                onClick={() => navigate(`/items/edit/${tableMeta?.rowData[0]}`)}
              >
                <EditIcon sx={{ color: '#be210b' }} />
              </IconButton>
              {/* Uncomment below if you want to add delete functionality */}
              {/* 
              <IconButton onClick={() => handleDelete(item.id)}>
                <DeleteIcon sx={{ color: '#be210b' }} />
              </IconButton>
              */}
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    expandableRows: false,
    download: false,
    filterOptions: 'fullWidth',
    selectableRows:
      isEqual(roles, ['SUPER ADMIN']) ||
      isEqual(roles, ['ADMIN', 'SUPER ADMIN'])
        ? 'multiple'
        : 'none',
    print: false,
    onRowsDelete: (rowsDeleted) => {
      setRowsToDelete(rowsDeleted);
      setOpenDeleteModal(true);
      return false;
    },
    // onRowsDelete: (rowsDeleted) => {
    //   const confirmDelete = window.confirm(
    //     `Are you sure you want to delete ${rowsDeleted.data.length} row(s)?`
    //   );
    //   if (confirmDelete) {
    //     handleDelete(rowsDeleted);
    //   } else {
    //     return false;
    //   }
    // },
    rowsPerPageOptions: [30, 50, 100],
    rowsPerPage: 30,
    viewColumns: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTable: {
          styleOverrides: {
            root: {
              boxShadow: 'none',
              backgroundColor: '#FFF',
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              backgroundColor: '#2F3542', // Keep background as you have it
              color: '#fff !important', // Ensure heading text is white
              border: 'none',
              '&:nth-last-of-type(1)': {
                borderTopRightRadius: '1rem',
                // borderBottomRightRadius: '0.2rem',
              },
            },
            sortActive: {
              color: '#fff !important', // Active sort icon color should also be white
            },
            sortAction: {
              '& .MuiTableSortLabel-icon': {
                color: '#fff !important', // Ensure sort icon stays white when active
              },
            },
            toolButton: {
              fontWeight: 'bold',
              fontSize: '0.675rem !important',
              paddingTop: '3px',
              paddingBottom: '3px',
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              padding: '2px 8px 2px 8px',
            },
          },
        },
        MuiTablePagination: {
          styleOverrides: {
            root: {
              backgroundColor: '#FFFFFF',
              height: '40px',
            },
            select: {
              backgroundColor: '#FFFFFF',
            },
            actions: {
              backgroundColor: '#FFFFFF',
            },
          },
        },
        MUIDataTableSelectCell: {
          styleOverrides: {
            headerCell: {
              border: 'none',
              borderTopLeftRadius: '0.2rem',
              borderBottomLeftRadius: '0.2rem',
              backgroundColor: '#2F3542',
              '& .MuiCheckbox-root': {
                color: '#fff',
                padding: '4px',
              },
            },
          },
        },
        MuiToolbar: {
          styleOverrides: {
            root: {
              minHeight: '30px!important',
              padding: '0px!important',
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              padding: '4px',
            },
          },
        },
        MUIDataTableBodyRow: {
          styleOverrides: {
            root: {
              '&:nth-of-type(even)': {
                backgroundColor: '#EAF3FF',
              },
              '&:nth-of-type(odd)': {
                backgroundColor: '#FFF',
              },
              '& td': {
                textAlign: 'left', // Center align body text data
                border: 'none',
              },
              marginBottom: '10px',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              color: '#fff',
              padding: '6px 0px !important',
              fontWeight: '550 !important',
              fontSize: '0.675rem !important',
              justifyContent: 'start',
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            root: {
              padding: '2px 26px !important',
              fontSize: '0.675rem',
            },
          },
        },
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
            },
          },
        },
        MuiPopover: {
          styleOverrides: {
            paper: {
              minWidth: '500px !important', // Increase the width of filter dropdown
              padding: '10px', // Add padding inside the dropdown
              borderRadius: '8px', // Optionally, round the corners
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)', // Add a subtle shadow for better visibility
              backgroundColor: '#fff', // Background color (you can change it)
            },
          },
        },
        MuiMenu: {
          styleOverrides: {
            paper: {
              minWidth: '200px  !important',
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
              fontWeight: 500,
              color: '#333',
              padding: '8px 16px',
              '&:hover': {
                backgroundColor: '#F5F5F5',
              },
            },
          },
        },
        MuiSelect: {
          styleOverrides: {
            select: {
              fontSize: '0.675rem !important',
              padding: '6px 10px',
            },
          },
        },
      },
    });

  return (
    <LayoutContainer>
      <AdminHeader title='PRODUCTS' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/items/new')}
          >
            ADD PRODUCT
          </Button>
        </Box>
        <ThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            // title={'Product List'}
            data={items}
            columns={columns}
            options={options}
          />
        </ThemeProvider>
      </div>
      <DeleteModal
        open={openDeleteModal}
        handleDailogClose={() => setOpenDeleteModal(false)}
        handleDelete={() => {
          handleDelete(rowsToDelete);
        }}
      />
    </LayoutContainer>
  );
};

export default ItemList;
